import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["resetBtn"]

  connect() {
    this.activeFilters = {
      rarity: [],
      category: [],
      zero_system: []
    }
  }

  toggle(event) {
    const btn = event.currentTarget
    const type = btn.dataset.filterType
    const value = btn.dataset.filterValue

    const index = this.activeFilters[type].indexOf(value)
    if (index === -1) {
      this.activeFilters[type].push(value)
      btn.classList.add("filter-btn-active")
    } else {
      this.activeFilters[type].splice(index, 1)
      btn.classList.remove("filter-btn-active")
    }

    this.applyFilters()
    this.updateResetBtn()
  }

  applyFilters() {
    const cards = document.querySelectorAll(".equipment-card-link:not([data-filter-ignore] .equipment-card-link)")

    cards.forEach(card => {
      if (card.closest("[data-filter-ignore]")) return
      const eq = card.querySelector(".equipment-card")
      const rarity = eq.dataset.rarity
      const category = eq.dataset.category
      const zeroSystem = eq.dataset.zeroSystem

      const rarityMatch = this.activeFilters.rarity.length === 0 || this.activeFilters.rarity.includes(rarity)
      const categoryMatch = this.activeFilters.category.length === 0 || this.activeFilters.category.includes(category)
      const systemMatch = this.activeFilters.zero_system.length === 0 || this.activeFilters.zero_system.includes(zeroSystem)

      card.style.display = rarityMatch && categoryMatch && systemMatch ? "" : "none"
    })
  }

  reset() {
    this.activeFilters = {
      rarity: [],
      category: [],
      zero_system: []
    }

    document.querySelectorAll(".filter-btn-active").forEach(btn => {
      btn.classList.remove("filter-btn-active")
    })

    this.applyFilters()
    this.updateResetBtn()
  }

  updateResetBtn() {
    const hasActive = Object.values(this.activeFilters).some(arr => arr.length > 0)
    this.resetBtnTarget.classList.toggle("filter-reset-active", hasActive)
  }
}
